import { getDate, isSameDay } from "date-fns";
import { t } from "@/i18n-js/instance";
import { CurrentPostContextProvider } from "@circle-react/contexts";
import { getMonthName } from "@circle-react/helpers/dateTimeHelpers/getName";
import type { Event } from "@circle-react/types/Event";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { EventItem } from "./EventItem";

interface MobileViewListProps {
  date: Date;
  events: Event[];
  onChange: (event: Event) => Promise<void>;
  onDestroy: (eventId: number) => void;
}

export const MobileViewList = ({
  date,
  events,
  onDestroy,
  onChange,
}: MobileViewListProps) => {
  const filteredEvents = events.filter(event => {
    const { starts_at: startsAt, ends_at: endsAt } =
      event?.event_setting_attributes || {};
    if (!startsAt || !endsAt) return false;
    const startDate = new Date(startsAt);
    const endDate = new Date(endsAt);
    const isDateInRange = date >= startDate && date <= endDate; //Multiday event
    return isSameDay(new Date(startsAt), date) || isDateInRange;
  });

  return (
    <div className="mt-6">
      <Typography.TitleMd>
        {`${getMonthName(date.toDateString())} ${getDate(date)}`}
      </Typography.TitleMd>
      <div className="mt-4">
        {filteredEvents.length == 0 && (
          <Typography.BodyMd>{t("all_events.no_events")}</Typography.BodyMd>
        )}
        <div className="-mx-6">
          {filteredEvents.map(event => (
            <CurrentPostContextProvider post={event} key={event.id}>
              <EventItem onDestroy={onDestroy} onChange={onChange} />
            </CurrentPostContextProvider>
          ))}
        </div>
      </div>
    </div>
  );
};
